export { ProductLink } from "./product-link";
export type { ProductLinkProps } from "./product-link";
